module.exports = __webpack_public_path__ + "static/xd-d4107b85a384e1d19426344aa851f272.png";